import { useEffect } from "react";

/**
 * Injects <meta name="robots" content="noindex,nofollow" /> while a page is
 * mounted. Removes it on unmount so public pages remain indexable.
 */
export default function NoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  return null;
}
